import { ReactNode } from 'react';

import Inline from '@perpay-web/components/design-system/Inline/Inline';
import SkeletonWrapper from '@perpay-web/components/design-system/Skeleton/SkeletonWrapper';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import { noop } from '@perpay-web/utils/noop';

import styles from './BankAccountDisplay.scss';

type AccountDisplayProps = {
    icon: string;
    title: string;
    subtitle: string;
    tooltip?: ReactNode;
    showChange?: boolean;
    onChange?: VoidFunction;
    prefix?: string | null;
    loading?: boolean;
};

const AccountDisplay = ({
    icon,
    title,
    tooltip = null,
    subtitle,
    showChange = false,
    onChange = noop,
    prefix = null,
    loading = false,
}: AccountDisplayProps) => (
    <div className={styles['bank-box']}>
        <div className={styles['bank-icon']}>
            <SkeletonWrapper
                loading={loading}
                className={styles['skeleton-icon']}
            >
                <img src={icon} alt='Bank Icon' />
            </SkeletonWrapper>
        </div>
        <div className={styles['bank-details']}>
            <div className={styles['bank-text-container']}>
                <div className={styles['bank-name-text']}>
                    <div
                        className={
                            loading
                                ? styles['loading-prefix-wrapper']
                                : styles['bank-name-content']
                        }
                    >
                        {prefix ? (
                            <span className={styles['bank-name-text-prefix']}>
                                {prefix}{' '}
                            </span>
                        ) : null}
                        <SkeletonWrapper
                            loading={loading}
                            className={styles['skeleton-title']}
                        >
                            <Inline className={styles['bank-title-row']}>
                                <span className={styles['bank-title']}>
                                    {title}
                                </span>
                                {tooltip || null}
                            </Inline>
                        </SkeletonWrapper>
                    </div>
                </div>
                <div className={styles['bank-account-number']}>
                    <SkeletonWrapper
                        loading={loading}
                        className={styles['skeleton-subtitle']}
                    >
                        {subtitle}
                    </SkeletonWrapper>
                </div>
            </div>
            {!loading && showChange ? (
                <div className={styles['edit-link']}>
                    <CustomLink onClick={onChange}>Change</CustomLink>
                </div>
            ) : null}
        </div>
    </div>
);

export default AccountDisplay;
